// library imports
import React, { useEffect, useState, useRef  } from "react";
import { useDispatch, useSelector } from "react-redux";

// User Component imports
import { PageContent, PageHeader, PageWrapper, PageContainer } from 'components/common/layout_element/LayoutElement';
import { Button, Row, Stack, Card, Pagination, WordCloudView, List, Icon, TextInput, ProgressBar} from "_core/components/common/UI";
import { CustomDateRangePicker, DateRadio, FitList} from "components/common/parts";
import * as Constants from "_core/configs/Constants";
import { setLoading, setMenuState, setErrorModal, setInitializeState } from "_core/slices/scene/SceneSlice";
import AdminUserChatLogInfoApi from "apis/AdminUserChatLogInfoApi";
import AdminGetLogAnalyticsApi from "apis/AdminGetLogAnalyticsApi";
import { InfoCard } from 'components/common/parts';
import Encoding from 'encoding-japanese';

// styles imports
import './AdminUserChatLog.scss';

const FilterLabel = ({ label, onClose }) => {
    return (
        <div className="filter-label">
            <span className="filter-label-text">{label}</span>
            <div className="filter-label-close" onClick={onClose}>
                <Icon icon="x-lg" size={10} />
            </div>
        </div>
    );
};

const AdminUserChatLog = () => {
    const dispatch = useDispatch();
    const ExecAdminUserChatLogInfoApi = AdminUserChatLogInfoApi();
    const ExecAdminGetLogAnalyticsApi = AdminGetLogAnalyticsApi();
    const { tUser } = useSelector((store) => store.transaction);
    const { iConstantList } = useSelector((store) => store.master);
    const { initializeState } = useSelector((store) => store.scene);

    const [analyticsLoading, setAnalyticsLoading] = useState(false);
    const [analyticsFirstLoaded, setAnalyticsFirstLoaded] = useState(false);

    const RangeLabelTypeKeys= Object.keys(Constants.RangeLabelType)
    const DispRangeLabelTypeValues= Object.values(Constants.RangeLabelType).filter(value => value !== Constants.RangeLabelType[Constants.RANGE_TYPE_CUSTOM])

    // 表示期間ラジオボタン
    const [dateRadioCheck, setDateRadioCheck] = useState(Constants.RANGE_TYPE_SHORT)
    // 日付カスタムラジオボタン表示内容
    const [dispCustomDate, setDispCustomDate] = useState(Constants.RangeLabelType[Constants.RANGE_TYPE_CUSTOM]);
    // 日付カスタムラジオボタンは文字が変動するため変数に格納しておく
    DispRangeLabelTypeValues.push(dispCustomDate)

    // 触っている日付範囲の制御
    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    useEffect(() => {
        setStartDate(dateRange[0])
        setEndDate(dateRange[1])
    }, [dateRange]);

    // 最終API実行対象日付範囲
    const [execApiStartDate, setExecApiStartDate] = useState(null);
    const [execApiEndDate, setExecApiEndDate] = useState(null);
    const [words, setWords] = useState(null);

    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
    const [filterParams, setFilterParams] = useState({
        hraris_account_id: "",
        hraris_company_id: "",
        session_id: "",
        question: "",
        answer: ""
    });
    const [editFilterParams, setEditFilterParams] = useState({
        hraris_account_id: "",
        hraris_company_id: "",
        session_id: "",
        question: "",
        answer: ""
    });
    const [filterInputsKey, setFilterInputsKey] = useState(0);
    
    const [isListLoading, setIsListLoading] = useState(false);

    // 表示終了日は当日
    const maxDate = new Date();
    // 表示開始日はその一年前の日付
    const minDate = new Date(maxDate);
    minDate.setFullYear(maxDate.getFullYear() - 1);

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [isDownloadCsv, setIsDownloadCsv] = useState(false);

    // カレンダー設定
    const [isDialogVisible, setIsDialogVisible] = useState(false);
    const dialogRef = useRef(null);
    const radioLabelOptions = { month: 'long', day: 'numeric' };

    const DEFAULT_PAGE = 1
    const DEFAULT_LIMIT_FLG = 1
    const DEFAULT_ANALYTICS_LIMIT_FLG = 0

    const COLOR_DICT = {
        0   : "#B3DCFE",
        10  : "#BBC4F1",
        20  : "#C6A8E1",
        30  : "#CB98D8",
        40  : "#D383CC",
        50  : "#DB6CBF",
        60  : "#E356B3",
        70  : "#EB41A7",
        80  : "#F22D9C",
        90  : "#FF0B88",
    }

    // チャットログリストデータ
    const [chatLogListData, setChatLogListData] = useState({
        columsize: {
            hraris_account_id:1, hraris_company_id:1, session_id:1, question:4, answer:4, regdate:1
        },
        title: {
            hraris_account_id: "HRarisアカウントID",
            hraris_company_id: "HRaris会社ID",
            session_id: "セッションID",
            question: "質問",
            answer: "返答",
            regdate: "日時",
        },
        value: [
        ]
    });
    // チャットログリストデータ
    const [wordCountData, setWordCountData] = useState({
        columsize: {
            word:3, count:1,  graph:2
        },
        title: {
            word: "単語",
            count: "回数",
            graph: "",
        },
        value: []
    });

    useEffect(() => {
        dispatch(setMenuState({ isHeader: false, isMenu: true, isFooter: false, isFullScreen: false }));
    }, [dispatch]);

    useEffect(() => {
        if(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete)
        {
            return
        }

        AdminUserChatLogInfoApiRequest(currentPage, DEFAULT_LIMIT_FLG, startDate, endDate)
    }, [words]);

    useEffect(() => {
        if(initializeState !== Constants.INITIALIZE_STATE.allComplete)
        {
            return
        }

        dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetching))

        // 表示対象日付の設定
        const { nextStartDate, nextEndDate } = SetRangeByTargetDay(dateRadioCheck)

        // API実行
        setAnalyticsLoading(true)
        AdminGetLogAnalyticsApiRequest(DEFAULT_PAGE, DEFAULT_ANALYTICS_LIMIT_FLG, nextStartDate, nextEndDate)

        // ログリストAPIも実行
        AdminUserChatLogInfoApiRequest(DEFAULT_PAGE, DEFAULT_LIMIT_FLG, nextStartDate, nextEndDate, false, true)
        
    }, [initializeState]);

    useEffect(() => {
        setIsDownloadCsv(chatLogListData.value.length > 0)
    }, [chatLogListData]);

    useEffect(() => {
        if (isDialogVisible) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDialogVisible]);

    // カレンダーの外側をクリック
    const handleClickOutside = (event) => {
        if (dialogRef.current && !dialogRef.current.contains(event.target)) 
        {
            setIsDialogVisible(false);
            setDateRange([startDate, endDate]); 
            if(startDate && endDate)
            {
                setDispCustomDate(startDate.toLocaleDateString('ja-JP', radioLabelOptions)+"-"+endDate.toLocaleDateString('ja-JP', radioLabelOptions))
            }
        }
    };
    
    // カレンダーから表示日付範囲一時変更
    const handleDateChange = (update) => {
        // startDateとendDateを一度に更新
        setDateRange(update); 
    };

    // カレンダーでキャンセル
    const handleCancel = () => {
        // 日付選択をリセット
        setDateRange([null, null]); 
    };
    
    // カレンダーから表示日付範囲変更確定
    const handleUpdate = () => {
        // カレンダーを非表示
        setIsDialogVisible(false);
        // カスタムラジオボタンに表示する日付更新
        setDispCustomDate(startDate.toLocaleDateString('ja-JP', radioLabelOptions)+"-"+endDate.toLocaleDateString('ja-JP', radioLabelOptions))
        // API実行
        setAnalyticsLoading(true)
        AdminGetLogAnalyticsApiRequest(DEFAULT_PAGE, DEFAULT_LIMIT_FLG, startDate, endDate)
    };

    // 指定日数間をデータにセット
    function SetRangeByTargetDay(targetDay)
    {
        // 取得必要日数の調整のため、マイナス１する
        targetDay = Number(targetDay)-1

        // 現在の日付を取得
        const nextEndDate = new Date();
        // 今日の日付を計算
        nextEndDate.setDate(nextEndDate.getDate());
        // 指定された日数分前の日付を計算
        const nextStartDate = new Date(nextEndDate);
        nextStartDate.setDate(nextEndDate.getDate() - targetDay);

        // 日付範囲を設定
        setDateRange([nextStartDate, nextEndDate]);

        return {
            nextStartDate: nextStartDate,
            nextEndDate: nextEndDate,
        };
    }

    const AdminUserChatLogInfoApiRequest = async (page, is_limit, nextStartDate, nextEndDate, isScroll=false, forceUpdate=false, overrideFilters = null) => {
        setIsListLoading(true)
        const tmpPage=currentPage
        setCurrentPage(page);

        // Check if dates are provided, fallback to state
        if (!nextStartDate || !nextEndDate) {
            nextStartDate = startDate;
            nextEndDate = endDate;
        }

        // Safety check: if still null, abort or handle appropriately
        if (!nextStartDate || !nextEndDate) {
            console.warn("Date range is null in AdminUserChatLogInfoApiRequest");
            setIsListLoading(false);
            return;
        }

        // リクエスト値をチェック
        let startDateStr = ""
        let nextStartDateStr = ""
        let endDateStr = ""
        let nextEndDateStr = ""

        if (execApiStartDate)
        {
            startDateStr = execApiStartDate
        }
        if (nextStartDate)
        {
            nextStartDateStr = nextStartDate.toLocaleDateString('ja-JP', radioLabelOptions) 
        }
        if (execApiEndDate)
        {
            endDateStr = execApiEndDate
        }
        if (nextEndDate)
        {
            nextEndDateStr = nextEndDate.toLocaleDateString('ja-JP', radioLabelOptions)
        }

        // 変化が無い場合はAPI実行しない
        if (! forceUpdate)
        {
            if (startDateStr == nextStartDateStr && endDateStr == nextEndDateStr)
            {
               // return
            }
        }

        setExecApiStartDate(nextStartDate ? nextStartDate.toISOString() : "")
        setExecApiEndDate(nextEndDate ? nextEndDate.toISOString() : "")

        // リクエスト値の設定
        const range_start_year = nextStartDate.getFullYear();
        const range_start_month = nextStartDate.getMonth() + 1;
        const range_start_day = nextStartDate.getDate();
        const range_end_year = nextEndDate.getFullYear();
        const range_end_month = nextEndDate.getMonth() + 1;
        const range_end_day = nextEndDate.getDate();

        // Use overrideFilters if provided, otherwise use current state
        const currentFilters = overrideFilters || filterParams;

        // 通信中の表示を出す
        dispatch(setLoading(true));
        const result = await ExecAdminUserChatLogInfoApi({
            "page":page,
            "is_limit":is_limit,
            "range_start_year": range_start_year,
            "range_start_month": range_start_month, 
            "range_start_day": range_start_day, 
            "range_end_year": range_end_year,
            "range_end_month": range_end_month, 
            "range_end_day": range_end_day,
            "hraris_account_id": currentFilters.hraris_account_id,
            "hraris_client_id": currentFilters.hraris_client_id,
            "hraris_company_id": currentFilters.hraris_company_id,
            "session_id": currentFilters.session_id,
            "question": currentFilters.question,
            "answer": currentFilters.answer,
        });

        // 通信中の表示を消す
        dispatch(setLoading(false));
        if (result.error || (result.response && result.response.error_code > 0))
        {
            setCurrentPage(tmpPage);
            setIsListLoading(false);
            CreateChatLogListData([]);
            setTotalPages(1);
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
        }
        else 
        {
            setIsListLoading(false)
            CreateChatLogListData(result.response.t_chat_log_list)
            setTotalPages(result.response.max_page)
            if (isScroll)
            {
                scrollToRef(listRef)
            }
        }
        dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetchComplete));
    };

    const AdminGetLogAnalyticsApiRequest = async (page, is_limit, nextStartDate, nextEndDate, overrideFilters = null) => {
        console.log("情報取得実行");
        const tmpPage=currentPage
        setCurrentPage(page);
        // リクエスト値をチェック
        let startDateStr = ""
        let nextStartDateStr = ""
        let endDateStr = ""
        let nextEndDateStr = ""

        if (execApiStartDate)
        {
            startDateStr = execApiStartDate
        }
        if (nextStartDate)
        {
            nextStartDateStr = nextStartDate.toLocaleDateString('ja-JP', radioLabelOptions) 
        }
        if (execApiEndDate)
        {
            endDateStr = execApiEndDate
        }
        if (nextEndDate)
        {
            nextEndDateStr = nextEndDate.toLocaleDateString('ja-JP', radioLabelOptions)
        }

        // 変化が無い場合はAPI実行しない
        if (startDateStr == nextStartDateStr && endDateStr == nextEndDateStr) {
            if (!overrideFilters) return
        }

        setExecApiStartDate(nextStartDate.toISOString())
        setExecApiEndDate(nextEndDate.toISOString())

        // リクエスト値の設定
        const range_start_year = nextStartDate.getFullYear();
        const range_start_month = nextStartDate.getMonth() + 1;
        const range_start_day = nextStartDate.getDate();
        const range_end_year = nextEndDate.getFullYear();
        const range_end_month = nextEndDate.getMonth() + 1;
        const range_end_day = nextEndDate.getDate();

        // Use overrideFilters if provided, otherwise use current state
        const currentFilters = overrideFilters || filterParams;

        // 通信中の表示を出す
        dispatch(setLoading(true));
        const result = await ExecAdminGetLogAnalyticsApi({
            "page":page,
            "is_limit":is_limit,
            "range_start_year": range_start_year,
            "range_start_month": range_start_month, 
            "range_start_day": range_start_day, 
            "range_end_year": range_end_year,
            "range_end_month": range_end_month, 
            "range_end_day": range_end_day,
            "hraris_account_id": currentFilters.hraris_account_id,
            "hraris_client_id": currentFilters.hraris_client_id,
            "hraris_company_id": currentFilters.hraris_company_id,
            "session_id": currentFilters.session_id,
            "question": currentFilters.question,
            "answer": currentFilters.answer,
        });

        // 通信中の表示を消す
        dispatch(setLoading(false));
        if (result.error || (result.response && result.response.error_code > 0))
        {
            setWords(null);
            CreateWordCountListData(null, nextStartDate, nextEndDate);
            setAnalyticsFirstLoaded(true);
            dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetchComplete));
            setAnalyticsLoading(false);
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
        }
        else 
        {
            if (result.response.words && result.response.words.length > 0)
            {
                setWords(result.response.words)
            }
            else
            {
                setWords(null)
            }
            
            CreateWordCountListData(result.response.words, nextStartDate, nextEndDate);
            setAnalyticsFirstLoaded(true)
            setTimeout(() => {
                dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetchComplete))
                setAnalyticsLoading(false)
                // CreateChatLogListData([])
                // setIsListLoading(false)
            }, 1000);
        }
    };

    const AdminUserChatLogInfoApiRequestForCsvDownload = async (page, is_limit, nextStartDate, nextEndDate) => {

        // Check if dates are provided, fallback to state
        if (!nextStartDate || !nextEndDate) {
            nextStartDate = startDate;
            nextEndDate = endDate;
        }

        if (!nextStartDate || !nextEndDate) return;

        // リクエスト値の設定
        const range_start_year = nextStartDate.getFullYear();
        const range_start_month = nextStartDate.getMonth() + 1;
        const range_start_day = nextStartDate.getDate();
        const range_end_year = nextEndDate.getFullYear();
        const range_end_month = nextEndDate.getMonth() + 1;
        const range_end_day = nextEndDate.getDate();

        // 通信中の表示を出す
        dispatch(setLoading(true));
        const result = await ExecAdminUserChatLogInfoApi({
            "page": page,
            "is_limit": is_limit,
            "range_start_year": range_start_year,
            "range_start_month": range_start_month, 
            "range_start_day": range_start_day, 
            "range_end_year": range_end_year,
            "range_end_month": range_end_month, 
            "range_end_day": range_end_day,
            "hraris_account_id": filterParams.hraris_account_id,
            "hraris_client_id": filterParams.hraris_client_id,
            "hraris_company_id": filterParams.hraris_company_id,
            "session_id": filterParams.session_id,
            "question": filterParams.question,
            "answer": filterParams.answer,
        });

        // 通信中の表示を消す
        dispatch(setLoading(false));
        if (result.error || (result.response && result.response.error_code > 0))
        {
            // エラーモーダル表示
            dispatch(setErrorModal({ show: true, text: result.response.error_detail }));
        }
        else 
        {
            dispatch(setInitializeState(Constants.INITIALIZE_STATE.pageDataFetchComplete));
            const csvData = generateCSV(result.response.t_chat_log_list);
            // SJIS に変換して Blob を作成
            const sjisArray = Encoding.convert(csvData, { to: 'SJIS', type: 'array' });
            const uint8Array = new Uint8Array(sjisArray);
            const blob = new Blob([uint8Array], { type: 'text/csv;charset=Shift_JIS' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = Constants.CHAT_LOG_CSV_FILE_NAME;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    };

    // CSVデータを生成する関数
    function generateCSV(data) {
        // ヘッダー行を定義
        const headers = ["HRarisアカウントID", "HRaris会社ID", "セッションID", "質問", "返答", "日時"];
        
        // CSV用の配列を作成し、ヘッダーを追加
        const csvRows = [headers.join(",")];

        // データ行を作成
        data.forEach(item => {
            const dateObject = new Date(item.regdate);
            const year = dateObject.getFullYear();
            const month = dateObject.getMonth() + 1; // 月は0から始まるため+1する
            const day = dateObject.getDate();
            const hours = String(dateObject.getHours()).padStart(2, '0');
            const minutes = String(dateObject.getMinutes()).padStart(2, '0');
            const seconds = String(dateObject.getSeconds()).padStart(2, '0');
            const row = [
                item.hraris_account_id,
                item.hraris_company_id,
                item.session_id,
                `"${item.question}"`,  // カンマや特殊文字がある可能性があるため、ダブルクオートで囲む
                `"${item.answer}"`,    // 同上
                item.regdate = `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`
            ];
            csvRows.push(row.join(","));
        });

        // CSVのテキストを結合
        return csvRows.join("\n");
    }

    // 表示期間ラジオボタンの変更
    const ChangeDateRadio = (value) => {

        // 選択中のラジオボタンをセット
        setDateRadioCheck(value);
        // 日付選択をリセット
        setDispCustomDate(Constants.RangeLabelType[Constants.RANGE_TYPE_CUSTOM])

        // カスタムの場合
        if (value == Constants.RANGE_TYPE_CUSTOM)
        {
            return
        }

        const { nextStartDate, nextEndDate } = SetRangeByTargetDay(value)
        
        // API実行
        setAnalyticsLoading(true)
        AdminGetLogAnalyticsApiRequest(DEFAULT_PAGE, DEFAULT_LIMIT_FLG, nextStartDate, nextEndDate)
    };

    // 表示期間ラジオボタンのクリック
    const ClickDateRadio = (value) => {
        // カスタムの場合
        if (value == Constants.RANGE_TYPE_CUSTOM)
        {
            setIsDialogVisible(true)
        }
    };

    function CreateChatLogListData(responseTChatLogList)
    {
        // List用データの生成
        const listData = {
            columsize: {
                hraris_account_id:1, hraris_company_id:1, session_id:1, question:4, answer:4, regdate:1
            },
            title: {
                hraris_account_id: "HRarisアカウントID",
                hraris_company_id: "HRaris会社ID",
                session_id: "セッションID",
                question: "質問",
                answer: "返答",
                regdate: "日時",
            },
            value: []
        }

        if (!responseTChatLogList)
        {
            setChatLogListData(listData);
            return
        }

        // 使用するデータ
        let tChatLogList;
        tChatLogList = Object.values(responseTChatLogList);

        if(tChatLogList.length > 0) {
            tChatLogList.forEach((tChatLog) => {
                // データの整形
                const tChatLogData = {};
                const titleData = {};
                // そのまま使えるデータを入れる
                tChatLogData.hraris_account_id = tChatLog.hraris_account_id;
                tChatLogData.hraris_company_id = tChatLog.hraris_company_id;
                tChatLogData.session_id = tChatLog.session_id;
                tChatLogData.question=tChatLog.question;
                tChatLogData.answer=tChatLog.answer;
                const dateObject = new Date(tChatLog.regdate);
                const year = dateObject.getFullYear();
                const month = dateObject.getMonth() + 1; // 月は0から始まるため+1する
                const day = dateObject.getDate();
                const hours = String(dateObject.getHours()).padStart(2, '0'); // 0埋め
                const minutes = String(dateObject.getMinutes()).padStart(2, '0'); // 0埋め
                const seconds = String(dateObject.getSeconds()).padStart(2, '0'); // 0埋め
                tChatLogData.regdate = `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;

                // 各データのクリック時処理
                const onClick = () => {
                    
                };

                // リスト用データの作成
                listData.value.push({
                    data: tChatLogData,
                    title: titleData,
                    onclick: onClick
                });
            });
        }
        setChatLogListData(listData);
    }

    // valueが0～100の整数値とする
    const getColor = (value) => {
        // COLOR_DICTのキーを数値配列に変換し昇順ソート
        const keys = Object.keys(COLOR_DICT).map(Number).sort((a, b) => a - b);
        
        // valueより大きいキーが出るまでループ、valueより大きいキーがあれば一つ前のキーの色を返す
        let matchedKey = keys[0];
        for (let i = 0; i < keys.length; i++) {
        if (value < keys[i]) {
            break;
        }
        matchedKey = keys[i];
        }
        
        return COLOR_DICT[matchedKey];
    }

    function CreateWordCountListData(words, nextStartDate, nextEndDate)
    {
        // List用データの生成
        const listData = {
            columsize: {
                word:3, count:1,  graph:2
            },
            title: {
                word: "単語",
                count: "回数",
                graph: "",
            },
            value: []
        }

        if (!words || words.length === 0)
        {
            setWordCountData(listData);
            return
        }

        // 使用するデータ
        const maxWord = words.reduce((prev, current) =>
            current.value > prev.value ? current : prev
        );
        
        if(words.length > 0) {
            const  maxFrequency = (words ? Math.max(...words.map((word) => Number(word.value))) : 1)
            const  minFrequency = (words ? Math.min(...words.map((word) => Number(word.value))) : 0)
            words.forEach((word) => {

                // データの整形
                const wordData = {};
                const titleData = {};
                // そのまま使えるデータを入れる
                wordData.text = word.text;
                wordData.value = word.value;
                const rate = ( Number(word.value) / Number(maxWord.value) ) * 100;

                const frequency = ((Number(word.value) - minFrequency) / (maxFrequency - minFrequency)) * 100; // 最大値からの割合(%)を取得

                const colorHex = getColor(frequency)

                const [r, g, b] = colorHex.match(/\w\w/g).map((hex) => parseInt(hex, 16)); // RGB値を抽出
                const colorStyle = `rgba(${r}, ${g}, ${b}, ${1})`; // RGBA形式の色を返す

                wordData.graph = (
                    <div className="graph-element" style={{
                        width : `${rate}%`,
                        backgroundColor : colorStyle
                    }}></div>
                );

                // 各データのクリック時処理
                const onClick = () => {
                    handleChangeWord(word.text, true, nextStartDate, nextEndDate);
                };

                // リスト用データの作成
                listData.value.push({
                    data: wordData,
                    title: titleData,
                    onclick: onClick
                });
            });
        }
        setWordCountData(listData);
    }

    const handlePageChange = (page) => {
        AdminUserChatLogInfoApiRequest(page, DEFAULT_LIMIT_FLG, startDate, endDate)
    };

    const handleChangeWord = (word, refreshLogs = false, nextStartDate = null, nextEndDate = null) => {
        if (word === null) {
            return;
        }
        setFilterParams(prev => ({ ...prev, question: word }));
        if (refreshLogs)
        {
            if (analyticsFirstLoaded)
            {
                scrollToRef(listRef)
            }
            const start = nextStartDate !== null ? nextStartDate : startDate;
            const end = nextEndDate !== null ? nextEndDate : endDate;
            AdminUserChatLogInfoApiRequest(DEFAULT_PAGE, DEFAULT_LIMIT_FLG, start, end, true, true, { ...filterParams, question: word });
        }
    };

    const handleGetLogAnalytics = () => {
        setAnalyticsLoading(true)
        AdminGetLogAnalyticsApiRequest(currentPage, DEFAULT_ANALYTICS_LIMIT_FLG, startDate, endDate)
    };

    const csvDownload = () => {
        AdminUserChatLogInfoApiRequestForCsvDownload(DEFAULT_PAGE, 0, startDate, endDate)
    };

    // フィルターを適用する
    const applyFilters = () => {
        setIsFilterDrawerOpen(false);
        setFilterParams(editFilterParams);
        setAnalyticsLoading(true);
        // フィルター適用後、ログリストを更新
        AdminUserChatLogInfoApiRequest(DEFAULT_PAGE, DEFAULT_LIMIT_FLG, startDate, endDate, true, true, editFilterParams);
        // フィルター適用後、ワードクラウドを更新
        AdminGetLogAnalyticsApiRequest(DEFAULT_PAGE, DEFAULT_ANALYTICS_LIMIT_FLG, startDate, endDate, editFilterParams);
    };

    // ドロワーを閉じる（適用せずに閉じた場合は編集内容を巻き戻す）
    const cancelFilterChanges = () => {
        setIsFilterDrawerOpen(false);
        setEditFilterParams(filterParams); // 元のフィルターに戻す
        setFilterInputsKey(Date.now()); // 入力コンポーネントの内部状態もリセット
    };

    // フィルターを削除する
    const removeFilter = (key) => {
        const overrides = { ...filterParams };
        if (key === 'hraris_account_id') {
            overrides.hraris_account_id = "";
        }
        if (key === 'hraris_client_id') {
            overrides.hraris_client_id = "";
        }
        if (key === 'hraris_company_id') {
            overrides.hraris_company_id = "";
        }
        if (key === 'session_id') {
            overrides.session_id = "";
        }
        if (key === 'question') {
            overrides.question = "";
        }
        if (key === 'answer') {
            overrides.answer = "";
        }
        
        setFilterParams(overrides);
        setAnalyticsLoading(true);

        AdminUserChatLogInfoApiRequest(DEFAULT_PAGE, DEFAULT_LIMIT_FLG, startDate, endDate, true, true, overrides);
        AdminGetLogAnalyticsApiRequest(DEFAULT_PAGE, DEFAULT_ANALYTICS_LIMIT_FLG, startDate, endDate, overrides);
    };

    const listRef = useRef(null);
    const topRef = useRef(null);

    const scrollToRef = (targetRef) => {
        console.log(targetRef.current);
        if (targetRef.current) {
            console.log("scroll started");
            targetRef.current.scrollIntoView({
                behavior: "smooth", // スムーズなスクロール
                block: "start",    // スクロール位置（'start', 'center', 'end' など）
            });
        }
    };

    return (
    <PageContent pageId="AdminUserChatLog">
        <div ref={topRef}></div>
        <PageHeader>
            {/* ここにページ内ヘッダー部分のコンポーネントを記述 */}
            <Stack className="spacing-4px">
                <div className="page-header-title">ログ</div>
                <div className="page-header-detail">{Constants.AI_NAME}が応答したチャットのログを確認できます。</div>
            </Stack>
        </PageHeader>
        <PageWrapper>
            <PageContainer>
                <Stack>
                    <Card className="analytics-area base-card margin-bottom-16px">
                        <Stack className="spacing-32px">
                            <Row className="flex-both width-full">
                                <Stack className="analytics-title">
                                    <div className="text-size-medium text-bold">分析結果</div>
                                    <div className="text-size-small">問い合わせログの分析結果を表示します。</div>
                                </Stack>
                                <Stack className="align-center flex-bottom height-full">
                                    <Button className="filter-button primary" onClick={() => {
                                        setEditFilterParams(filterParams);
                                        setFilterInputsKey(Date.now());
                                        setIsFilterDrawerOpen(true);
                                    }}>
                                        <Row className="flex-center spacing-8px width-fit">
                                            <Icon className="label-icon" icon="filter" size={16} />
                                            <div>フィルター</div>
                                        </Row>
                                    </Button>
                                </Stack>
                            </Row>
                            <div className="data-radio-stack">
                                <Row className= "row-stack-between spacing-32px">
                                    <Row className="flex-left">
                                        <DateRadio 
                                            name="range-date" 
                                            value={RangeLabelTypeKeys} 
                                            diffValue={DispRangeLabelTypeValues} 
                                            checked={dateRadioCheck} 
                                            onclick={(e) => ClickDateRadio(e)} 
                                            onchange={(e) => ChangeDateRadio(e)} 
                                            isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                        />
                                    </Row>
                                    <Row className="flex-right spacing-8px width-full">
                                        {/* <Button className={"dl-button "+(true ? "primary": "primary disabled")} onClick={() => {
                                            handleGetLogAnalytics();
                                        }}>
                                            <Row className="flex-center spacing-8px width-full">
                                                <Icon className="label-icon" icon="graph-up" size={16} />
                                                <div>分析</div>
                                            </Row>
                                        </Button> */}
                                        <Row className="search-input-area width-full relative flex-right align-center spacing-8px">
                                            {filterParams.question && <FilterLabel label={`質問: ${filterParams.question}`} onClose={() => removeFilter('question')} />}
                                            {filterParams.answer && <FilterLabel label={`回答: ${filterParams.answer}`} onClose={() => removeFilter('answer')} />}
                                            {filterParams.session_id && <FilterLabel label={`SessionID: ${filterParams.session_id}`} onClose={() => removeFilter('session_id')} />}
                                            {filterParams.hraris_account_id && <FilterLabel label={`HRarisアカウントID: ${filterParams.hraris_account_id}`} onClose={() => removeFilter('hraris_account_id')} />}
                                            {filterParams.hraris_company_id && <FilterLabel label={`HRaris会社ID: ${filterParams.hraris_company_id}`} onClose={() => removeFilter('hraris_company_id')} />}
                                        </Row>
                                    </Row>
                                </Row>
                            </div>
                            <div className={"filter-drawer-overlay " + (isFilterDrawerOpen ? "show" : "")} onClick={cancelFilterChanges}></div>
                            <div className={"filter-drawer " + (isFilterDrawerOpen ? "show" : "")}>
                                <Stack className="height-full spacing-16px">
                                    <Row className="flex-both align-center">
                                        <div className="text-size-medium text-bold">フィルター</div>
                                        <Row className="flex-right align-center spacing-8px">
                                            <Button className="secondary-border width-120px" onClick={() => {
                                                setEditFilterParams({
                                                    hraris_account_id: "",
                                                    hraris_company_id: "",
                                                    session_id: "",
                                                    question: "",
                                                    answer: ""
                                                });
                                                setFilterInputsKey(Date.now());
                                            }}>
                                                クリア
                                            </Button>
                                            <Button className="primary width-120px" onClick={applyFilters}>
                                                適用
                                            </Button>
                                        </Row>
                                    </Row>
                                    <Stack className="spacing-8px flex-grow scroll-y">
                                        <Stack className="spacing-4px">
                                            <div className="text-size-small text-bold">HRarisアカウントID</div>
                                            <TextInput key={`account-${filterInputsKey}`} type="number" default={editFilterParams.hraris_account_id} value={editFilterParams.hraris_account_id} onchange={(e) => setEditFilterParams({...editFilterParams, hraris_account_id: e.target.value})} placeholder="HRarisアカウントIDを入力" />
                                        </Stack>
                                        <Stack className="spacing-4px">
                                            <div className="text-size-small text-bold">HRaris会社ID</div>
                                            <TextInput key={`company-${filterInputsKey}`} type="text" default={editFilterParams.hraris_company_id} value={editFilterParams.hraris_company_id} onchange={(e) => setEditFilterParams({...editFilterParams, hraris_company_id: e.target.value})} placeholder="HRaris会社IDを入力" />
                                        </Stack>
                                        <Stack className="spacing-4px">
                                            <div className="text-size-small text-bold">セッションID</div>
                                            <TextInput key={`session-${filterInputsKey}`} default={editFilterParams.session_id} value={editFilterParams.session_id} onchange={(e) => setEditFilterParams({...editFilterParams, session_id: e.target.value})} placeholder="セッションIDを入力" />
                                        </Stack>
                                        <Stack className="spacing-4px">
                                            <div className="text-size-small text-bold">質問</div>
                                            <TextInput key={`q-${filterInputsKey}`} default={editFilterParams.question} value={editFilterParams.question} onchange={(e) => setEditFilterParams({...editFilterParams, question: e.target.value})} placeholder="質問内のキーワード" />
                                        </Stack>
                                        <Stack className="spacing-4px">
                                            <div className="text-size-small text-bold">回答</div>
                                            <TextInput key={`a-${filterInputsKey}`} default={editFilterParams.answer} value={editFilterParams.answer} onchange={(e) => setEditFilterParams({...editFilterParams, answer: e.target.value})} placeholder="回答内のキーワード" />
                                        </Stack>
                                    </Stack>
                                </Stack>
                            </div>
                            <Row className={"analytics-area-row spacing-8px" + ((words || analyticsLoading) ? " show" : "")} >
                                <Stack className="wordcloud-area width-50percent height-full spacing-8px">
                                    {/* <Row className="flex-center text-size-light-medium">ワードクラウド</Row> */}
                                    <WordCloudView
                                        className="wordcloud-area" 
                                        words={words}
                                        width={440}
                                        height={280}
                                        onWordClick={(word) => {
                                            handleChangeWord(word, true);
                                        }}
                                        colorDict={COLOR_DICT}
                                    ></WordCloudView>
                                </Stack>
                                <Stack className="ranking-area width-50percent spacing-8px">
                                    {/* <Row className="flex-center text-size-light-medium">ワードランキング</Row> */}
                                    <List
                                        list={wordCountData}
                                        header={true}
                                        scrollbar={"scrollbar"}
                                        className="ranking-list"
                                        isLoading={((! words) || analyticsLoading) ? true : false}
                                        loadingCount={0}
                                    />
                                </Stack>
                                {(analyticsLoading || !analyticsFirstLoaded) &&
                                    <Stack className="analytics-loading flex-center align-center">
                                        <div className="loading-spinner">
                                            <div className="loader"></div>
                                        </div>
                                    </Stack>
                                }
                                {(analyticsFirstLoaded && !analyticsLoading && !words) &&
                                    <Stack className="empty-info flex-center align-center">
                                        <InfoCard className="danger width-full">表示するデータがありません。</InfoCard>
                                    </Stack>
                                }
                            </Row>
                        </Stack>
                    </Card>
                    <div ref={listRef}></div>
                    <Card className = "base-card">
                        <Row className="flex-both width-full">
                            <Stack className="analytics-title">
                                <div className="text-size-medium text-bold">ログ詳細</div>
                                <div className="text-size-small">問い合わせログの詳細を表示します。</div>
                            </Stack>
                            <div className="data-radio-stack">
                                <Row className= "row-stack-between">
                                    <Row className="flex-right spacing-8px width-full">
                                        <Button className={"dl-button "+(isDownloadCsv ? "primary": "primary disabled")} onClick={csvDownload}>
                                            <Row className="flex-center spacing-8px width-full">
                                                <Icon className="label-icon" icon="download" size={18} />
                                                <div>ダウンロード</div>
                                            </Row>
                                        </Button>
                                    </Row>
                                </Row>
                            </div>
                        </Row>
                        <Stack className="spacing-16px align-center addmergin">
                            <div className="calender-container">
                                {isDialogVisible && (
                                <div className="calender-dialog" ref={dialogRef}>
                                    <CustomDateRangePicker
                                        selected={startDate}
                                        onChange={handleDateChange}
                                        startDate={startDate}
                                        endDate={endDate}
                                        selectsRange
                                        inline
                                        handleCancel={handleCancel}
                                        handleUpdate={handleUpdate}
                                        minDate ={minDate}
                                        maxDate ={maxDate}
                                        isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                                    />
                                </div>
                                )}
                            </div>
                            <FitList
                                list={chatLogListData}
                                header={true}
                                scrollbar={"scrollbar"}
                                isLoading={(isListLoading || (initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete)) ? true : false}
                            />
                            <Pagination
                                totalPages={totalPages}
                                currentPage={currentPage}
                                onChange = {handlePageChange}
                                isLoading={(initializeState < Constants.INITIALIZE_STATE.pageDataFetchComplete) ? true : false}
                            />
                        </Stack>
                    </Card>
                </Stack>
                <Button className="scroll-button primary" onClick={() => {scrollToRef(topRef)}}>
                    <Icon icon="chevron-up" size={28} className="copy-icon"/>
                </Button>
            </PageContainer>
        </PageWrapper>
    </PageContent>
    );
};

export default AdminUserChatLog;